import React, { useEffect, useState } from "react";
import { APIError, fetchHistory } from "../../api";
import { GameSummaryView } from "./GameSummaryView";
import { MatchSummary, RegionV5, Summoner } from "../../types/riot";
import { loadMapStateFromGame } from "../../states/frameState";
import { closeAllModals } from "../../states/uiStates";
import { useApi } from "@shared/api/hooks";
import { regionV4toV5, trackEvent } from "@shared/utils";

interface GamesHistoryViewProps {
	summoner: Summoner;
	region: RegionV5;
	queueId: string;
}

const GamesHistoryView: React.FC<GamesHistoryViewProps> = (props) => {
	const { loading, request } = useApi(fetchHistory);
	const [history, setHistory] = useState<string[]>([]);
	const [error, setError] = useState<APIError>();

	useEffect(() => {
		(async () => {
			const response = await request(props.region, props.summoner.puuid, props.queueId);

			if (!response) {
				setError({ message: "Unknown error", code: 500 });
				return;
			}

			if (response.error) {
				setError(response.error);
				return;
			}

			if (!response.history) {
				setError({ message: "Unknown error", code: 500 });
				return;
			}

			setHistory(response.history);
		})();
	}, [props.summoner, props.region, props.queueId]);

	const handleClick = async (summary: MatchSummary) => {
		if (!summary.platformId) {
			return;
		}
		trackEvent("import_summoner");
		loadMapStateFromGame(
			regionV4toV5(summary.platformId),
			summary.platformId + "_" + summary.gameId,
		);
		closeAllModals();
		// todo f4 warn that importing a game will clear the overlay
	};

	if (loading) {
		return <div className={"text-white"}>Loading Game History...</div>;
	}

	if (history.length === 0) {
		return <div className={"text-white opacity-80"}>No recent games found.</div>;
	}

	return (
		<div className={"flex flex-col gap-2"}>
			{!loading && error && <div className={"text-red-400 mt-2"}>{error.message}</div>}
			{history.map((gameId) => (
				<GameSummaryView
					key={gameId}
					region={props.region}
					gameId={gameId}
					playerId={props.summoner.puuid}
					onClick={handleClick}
				/>
			))}
		</div>
	);
};

export { GamesHistoryView };
